import { LeaveCreditKind, type LeaveCreditKindValue } from '../leaveTypes';

/** Six characters, so two generated rows never collide on the catalog's unique name. */
function uid(): string {
  return Math.random().toString(36).slice(2, 8).toUpperCase();
}

/**
 * A plausible leave type, filled in far enough that the row produces a readable profile.
 *
 * **"The primary action enables" is the floor, not the target.** A type carrying only its name
 * makes a profile of em dashes, which exercises nothing — so the description and the kind are
 * filled too, and a ledger kind gets the rate that makes its own column mean something.
 */
export function sampleLeaveType(): {
  name: string;
  code: string;
  description: string;
  creditKind: LeaveCreditKindValue;
  monthlyAccrualDays: string;
} {
  const suffix = uid();

  /*
    A LEDGER kind, deliberately: it is the one that exercises the rate field, the Used and
    Adjusted columns and the ledger entry form behind them. A granted sample would leave half
    the surface untouched and the generated row would look complete while proving less.
  */
  return {
    name: `Sample Leave ${suffix}`,
    code: `SMP${suffix.slice(0, 3)}`,
    description: 'Generated for testing. Earned monthly and drawn down as it is taken.',
    creditKind: LeaveCreditKind.Ledger,
    monthlyAccrualDays: '1.25',
  };
}
